<template>

  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <Error_messages :error_message="messages.error" :success_message = "messages.success"/>
    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider :vid="inputType" :name="inputType" rules="required" v-slot="{ passed, failed, failedRules, errors }">
    
        <b-form-group v-if="inputType === 'phone'" label="Phone" >
          <phone-number
                    v-model="user.phone"
                    :rules="rules.phone"
                    :errors.sync="phone_value_change" 
                  />
                  <p v-if="phone_value_change" class="text-danger">{{ phone_value_change }}</p>
        </b-form-group>

            <b-form-group v-else label="Email" label-for="email" >
                    <b-form-input id="email" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     type="email" placeholder="Enter your email..." v-model="user.email"></b-form-input>
                    <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.email ? validation_messages.email[Object.keys(failedRules)[0]] : errors[0] }} </div>
            </b-form-group>
          </ValidationProvider>
      <p @click="toggleInputType" style="cursor:pointer; width: fit-content;" class=" text-primary font-size-16 font-weight-bold mb-3">
           {{ inputType === 'phone' ? 'Have an email?' : 'Have a phone number ?' }}
          </p>

      <ValidationProvider vid="password" name="Password" :rules="rules.password" v-slot="{ passed, failed, failedRules, errors  }">
        <div class="form-group">
          <a href="/auth/password-reset1" class="float-right">
            Forgot password?
          </a>
          <b-form-group label="Password " label-for="password">
              <b-form-input id="password" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     type="password" placeholder="Enter your Password..." v-model="user.password"></b-form-input>
              <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.password ? validation_messages.password[Object.keys(failedRules)[0]] : errors[0] }} </div>
          </b-form-group>
        </div>
      </ValidationProvider>
      <div class="d-inline-block w-100">
        <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
          <input type="checkbox" class="custom-control-input" :id="formType">
          <label class="custom-control-label" :for="formType">Remember Me</label>
        </div>
        
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
        <button v-else type="submit" class="btn btn-primary float-right">Login</button>
      </div>

      <div class="sign-info">
          <span class="dark-color d-inline-block line-height-2">
            Don't have an account?
            <router-link to="/auth/sign-up1" class="iq-waves-effect pr-4">
              Sign up
            </router-link>
          </span>
        <social-login-form></social-login-form>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { loginUser } from '@/API/UsersAPIs';
import { setAccessToken } from '@/Utils/authentication';
import SocialLoginForm from './SocialLoginForm'
import PhoneNumber from '@/components/PhoneNumber.vue';
import Error_messages from "@/helpers/error_messages.vue";
import { core } from '@/config/pluginInit';
export default {
  name: 'SignIn1Form',
  components: { SocialLoginForm, PhoneNumber,Error_messages},
  props: ['formType', 'email', 'password'],
  data(){
    return {
      phone_value_change: '',
      user:{ email: '', password: '', phone: '', },
      isPhoneValid: false,
      inputType: 'email',
      loading:false,
      messages: { error: "", success: "" },
      rules: { email: 'required|email', password: 'required|min:8', phone: 'required'},
      validation_messages: {
        email: {
          required: 'Your email is required',
        },
        phone: {
          required: 'Phone is required',
        },
        password: {
          required: 'Password is required',
          min: 'Minimum length 8 characters required'
        },
      }
    }
  },
  mounted() {
  core.index();
},
  methods: {

    toggleInputType() {
      this.inputType = this.inputType === 'phone' ? 'email' : 'phone';
      this.changeChoice = this.inputType === 'phone' ? 'Enter your phone number to reset your password.' : 'Enter your email address to reset your password.';
      //  check if user choose phone input then set email to null and vice versa
      this.inputType === 'phone' ? this.user.email = null : this.user.phone = null;
    },
   
    async onSubmit () {
      if (this.inputType === 'phone' && this.phone_value_change) return;
      const userForm = this.inputType === 'phone'
       ? { phone: this.user.phone.formattedNumber , password: this.user.password, dashboard:true }
      :{ email: this.user.email, password:this.user.password, dashboard:true }; 
       this.loading = true;

      try {
        const user = await loginUser(userForm);
        if (user.token) {
          setAccessToken(user.token)
          this.$store.commit('User/setUser', user);
          const token = localStorage.getItem('token');
          if (token) {
            // this.$router.push({ name: 'dashboard.home-1' }); 
            return window.location.replace('/');
          }
          this.messages.error =""
          this.loading = false
          return;
        }
      } catch (error) {
        this.messages.error = 
        error.message === "Network Error" ? error.message :
        error.response.data.message === "Invalid user credentials" ? error.response.data.message :
        this.inputType === 'email' ? error.response.data.errors.email[0] :
        this.inputType === 'phone' && error.response.data.errors.phone_required[0]

    }finally{ this.loading = false }
     
    
  },
  }
}
</script>
